export default __webpack_public_path__ + "static/4-1--e69eed9f3be69a28c4170b90e979dfb5.png";